let config = {
	// api请求地址
	baseUrl: 'https://b2b.cqklszkj.cn/',
	// baseUrl: 'http://192.168.110.30:88/',
	// 默认商家地址
	defaultWarehouseHost:'https://b2b.cqklszkj.cn',
	// 图片域名
	imgDomain: 'https://b2b.cqklszkj.cn/',
	// 前端域名
	webDomain: 'https://b2b.cqklszkj.cn/',
	// 腾讯地图key
    mpKey: "",
	// 客服
    webSocket: "",
	// 本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
    pingInterval: 1500,
	// 客服地址
    keFuUrl: "",
    // 是否允许分仓与默认版本之间切换
    allowVersion_switch:false
};

export default config;
// let config = {
// 	// api请求地址
// 	baseUrl: 'https://kl.cqklszkj.cn/',
// 	// 默认商家地址
// 	defaultWarehouseHost:'https://kl.cqklszkj.cn',
// 	// 图片域名
// 	imgDomain: 'https://kl.cqklszkj.cn/',
// 	// 前端域名
// 	webDomain: 'https://kl.cqklszkj.cn/',
// 	// 腾讯地图key
//     mpKey: "",
// 	// 客服
//     webSocket: "",
// 	// 本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
//     pingInterval: 1500,
// 	// 客服地址
//     keFuUrl: "",
//     // 是否允许分仓与默认版本之间切换
//     allowVersion_switch:false
// };

// export default config;
